import React from 'react'
import {createRoot} from 'react-dom/client';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './Componentes/App'
import theme from './Tools/Theme';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
